import * as AppCore from '@/utilities/AppCore';
import { VisualFile } from '@/types/visual_file';

export interface Profile {
  profile_id: number,
  name: string,
  description: string,
  visuals: VisualFile[],
  uniqueid: string,
  instagram?: string,
  tiktok?: string,
  snapchat?: string,
  facebook?: string,
  x?: string,
  website?: string,
  optionalfilled?: boolean,
  children_have?: number,
  children_want?: number,
  educationlevel?: number,
  job_name?: string,
  job_title?: string,
  sexualorientation?: number,
  pronouns?: string,
  pets?: number,
  drink?: number,
  smoke?: number,
  weed?: number,
  drugs?: number,
  exercise?: number,
  activeonsocial?: number,
  lookingfor?: number,
  relationshiptype?: number,
  languages?: string,
  interests?: number,
  status?: string,
  quote?: string,
  interests_general?: string,
  interests_music?: string,
  interests_movies?: string,
  interests_games?: string,
  interests_books?: string,
  interests_groups?: string,
  desiredqualities?: number,
  ethnicity?: number,
  politics?: number,
  religion?: number,
}

export const UNKNOWN_PROFILE : Profile = {
  profile_id: -1,
  name: "Unknown",
  description: "Unknown",
  visuals: [],
  uniqueid: "unknown",
};

export enum Ethnicity {
  ETHNICITY_NONE = 0,
  ETHNICITY_WHITE = 1,
  ETHNICITY_BLACK = 2,
  ETHNICITY_EAST_ASIAN = 4,
  ETHNICITY_HISPANIC = 8,
  ETHNICITY_MIDDLE_EASTERN = 16,
  ETHNICITY_NATIVE_AMERICAN = 32,
  ETHNICITY_PACIFIC_ISLANDER = 64,
  ETHNICITY_SOUTH_ASIAN = 128,
  ETHNICITY_SOUTHEAST_ASIAN = 256,
  ETHNICITY_OTHER = 512,
};

export const EthnicityNames : Map<number, string> = new Map([
  [Ethnicity.ETHNICITY_WHITE, "White/Caucasian"],
  [Ethnicity.ETHNICITY_BLACK, "Black/African Descent"],
  [Ethnicity.ETHNICITY_EAST_ASIAN, "East Asian"],
  [Ethnicity.ETHNICITY_HISPANIC, "Hispanic/Latino"],
  [Ethnicity.ETHNICITY_MIDDLE_EASTERN, "Middle Eastern"],
  [Ethnicity.ETHNICITY_NATIVE_AMERICAN, "Native American"],
  [Ethnicity.ETHNICITY_PACIFIC_ISLANDER, "Pacific Islander"],
  [Ethnicity.ETHNICITY_SOUTH_ASIAN, "South Asian"],
  [Ethnicity.ETHNICITY_SOUTHEAST_ASIAN, "Southeast Asian"],
  [Ethnicity.ETHNICITY_OTHER, "Other"],
]);

export function getEthnicities(profile: Profile) : string {
  return AppCore.getEnumValuesJoined(profile.ethnicity, Ethnicity, EthnicityNames);
}

export enum Religion {
  RELIGION_NONE = 0,
  RELIGION_AGNOSTIC = 1,
  RELIGION_ATHEIST = 2,
  RELIGION_BUDDHIST = 4,
  RELIGION_CATHOLIC = 8,
  RELIGION_CHRISTIAN = 16,
  RELIGION_HINDU = 32,
  RELIGION_JEWISH = 64,
  RELIGION_MUSLIM = 128,
  RELIGION_SIKH = 256,
  RELIGION_SPIRITUAL = 512,
  RELIGION_OTHER = 1024,
};

export const ReligionNames : Map<number, string> = new Map([
  [Religion.RELIGION_AGNOSTIC, "Agnostic"],
  [Religion.RELIGION_ATHEIST, "Atheist"],
  [Religion.RELIGION_BUDDHIST, "Buddhist"],
  [Religion.RELIGION_CATHOLIC, "Catholic"],
  [Religion.RELIGION_CHRISTIAN, "Christian"],
  [Religion.RELIGION_HINDU, "Hindu"],
  [Religion.RELIGION_JEWISH, "Jewish"],
  [Religion.RELIGION_MUSLIM, "Muslim"],
  [Religion.RELIGION_SIKH, "Sikh"],
  [Religion.RELIGION_SPIRITUAL, "Spiritual"],
  [Religion.RELIGION_OTHER, "Other"],
]);

export function getReligions(profile: Profile) : string {
  return AppCore.getEnumValuesJoined(profile.religion, Religion, ReligionNames);
}
